import { render, staticRenderFns } from "./InventoryLogs.vue?vue&type=template&id=56496e8b&scoped=true&"
import script from "./InventoryLogs.vue?vue&type=script&lang=js&"
export * from "./InventoryLogs.vue?vue&type=script&lang=js&"
import style0 from "./InventoryLogs.vue?vue&type=style&index=0&id=56496e8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56496e8b",
  null
  
)

export default component.exports